import { ToolboxItem, ToolboxItemType } from '@occc-app/design-system';
import { useChainId } from '@occc-app/Chain/hooks';
import { useStoredValueProgramsQuery } from '@occc/graphql';

import { routeCreator } from '../stored-value.utils';

export const StoredValueToolboxItem = () => {
  const chainId = useChainId();

  const { data, loading } = useStoredValueProgramsQuery({
    variables: {
      first: 1,
      filter: chainId ? { chainIdEquals: chainId } : undefined,
    },
    fetchPolicy: 'cache-and-network',
    notifyOnNetworkStatusChange: true,
  });

  const storedValueProgramId = data?.storedValuePrograms.edges[0]?.node.id;
  const linkToEdit = storedValueProgramId ? routeCreator.update(storedValueProgramId) : undefined;
  const linkToCreate = storedValueProgramId ? undefined : routeCreator.create;

  return (
    <ToolboxItem
      title='Stored Value'
      description='Define a mechanism by which points can be burned for stored value'
      type={ToolboxItemType.StoredValue}
      linkToCreate={linkToCreate}
      linkToEdit={linkToEdit}
      loading={loading}
    />
  );
};
